<template>
  <div class="md:hidden bg-white border-t border-gray-100">
    <div class="px-4 py-4 space-y-1">
      <a
        v-for="item in navItems"
        :key="item.href"
        :href="item.href"
        class="block px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-xl font-medium transition-colors"
        @click="$emit('close')"
      >
        {{ item.label }}
      </a>
      <div class="pt-3 mt-3 border-t border-gray-100 space-y-2">
        <a
          v-if="showSignUpButton"
          :href="loginUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="block w-full px-4 py-3 text-center text-gray-700 hover:bg-gray-50 rounded-xl font-medium transition-colors"
          @click="$emit('close')"
        >
          Login
        </a>
        <button
          v-if="showSignUpButton"
          class="block w-full px-4 py-3 text-center text-white font-semibold bg-gradient-to-r from-green-500 to-emerald-600 rounded-xl shadow-md shadow-green-500/20 active:scale-[0.98] transition-all"
          @click="scrollToPricing(); $emit('close')"
        >
          Começar Agora
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const navItems = [
  { href: '#benefits', label: 'Benefícios' },
  { href: '#agents', label: 'Agentes' },
  { href: '#pricing', label: 'Preços' },
  { href: '/sistemas', label: 'Sistemas' }
]

defineEmits<{
  close: []
}>()

import { computed } from 'vue';
import { useRouter } from 'vue-router'

const router = useRouter();

// Função para capturar UTMs da URL atual
const getUtmParams = (): string => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = new URLSearchParams();
  
  // Lista de parâmetros UTM comuns
  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  
  // Também captura o parâmetro 'ref' se existir
  const refParam = urlParams.get('ref');
  if (refParam) {
    utmParams.set('ref', refParam);
  }

  utmKeys.forEach(key => {
    const value = urlParams.get(key);
    if (value) {
      utmParams.set(key, value);
    }
  });
  
  return utmParams.toString();
};

// Função para adicionar UTMs a uma URL
const addUtmsToUrl = (baseUrl: string): string => {
  const utmString = getUtmParams();
  if (!utmString) return baseUrl;
  
  const separator = baseUrl.includes('?') ? '&' : '?';
  return `${baseUrl}${separator}${utmString}`;
};

const showSignUpButton = computed(() => {
  return !['imobiliarias', 'clinicas'].includes(router.currentRoute.value.name as string);
});

const scrollToPricing = () => {
  const pricingSection = document.getElementById('pricing')
  if (pricingSection) {
    pricingSection.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    })
  } else {
    router.push('/');
    setTimeout(() => {
        const element = document.getElementById('pricing');
        if (element) element.scrollIntoView({ behavior: 'smooth' })
      }, 400);
  }
}

const loginUrl = addUtmsToUrl('https://app.autovolt.ai/login')
</script>
